document.addEventListener('DOMContentLoaded', () => {
  const mobileOpenButton = document.querySelector('[mobile-open-button]')
  const mobileCloseButton = document.querySelector('[mobile-close-button]')
  const mobileMenu = document.querySelector('[mobile-menu]')

  mobileOpenButton?.addEventListener('click', () => {
    mobileMenu?.classList.add('is-open')
    document.body.classList.toggle('overflow-hidden')
  })

  mobileCloseButton?.addEventListener('click', () => {
    mobileMenu?.classList.remove('is-open')
    document.body.classList.remove('overflow-hidden')
  })


  const header = document.querySelector('header') as HTMLElement | null;
  let lastScrollY = window.scrollY;

  if (header) {
    // Agregar transición al header
    header.style.transition = 'transform 0.3s ease';

    window.addEventListener('scroll', () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY) {
        // Scroll hacia abajo: mover el header hacia arriba
        header.style.transform = 'translateY(-100%)';
      } else {
        // Scroll hacia arriba: mover el header hacia abajo
        header.style.transform = 'translateY(0)';
      }

      lastScrollY = currentScrollY;
    });
  }
})